import {useDebugValue} from 'react';

import {
    useSubmitSummaryEvents
} from './';

function useSubmitSummary(props) {
    const {
        events
    } = useSubmitSummaryEvents(props);

    const result = {
        events
    };

    useDebugValue(result);

    return result;
}

export {useSubmitSummary};
